// extracted by mini-css-extract-plugin
module.exports = {"imgBorder":"_4VrFW","fancyImgBorder":"Z4ILH","img":"_2aGLK","imgOverlay":"_3TjWX"};